import { ApiPaths } from 'api/constants';
import {
  FtpConnectionGeneral,
  ValidateFtpCredentials,
  ValidateFtpCredentialsResult,
} from 'api/endpoints/ftpConnections';
import ApiUrlParams from 'constants/apiUrlParams';
import { ApiResponseAsync } from 'container/models';

import BaseRepo from '../../BaseRepo';
import {
  IManagementFTPRepo,
  UpdateFtpConnectionParams,
} from './IManagementFTPRepo';

export class ManagementFTPRepo extends BaseRepo implements IManagementFTPRepo {
  validateCredentials = (
    connection: ValidateFtpCredentials
  ): ApiResponseAsync<ValidateFtpCredentialsResult> => {
    const link = ApiPaths.ftpConnections.validateCredentials._();

    return this.helpers.handlePost(link, connection);
  };

  deleteConnection = (
    ftpConnectionDetails: FtpConnectionGeneral
  ): ApiResponseAsync<void> => {
    const link = ApiPaths.ftpConnections.byId._({
      [ApiUrlParams.ftpConnectionId]: ftpConnectionDetails.id,
    });
    return this.helpers.handleDelete(link);
  };

  updateConnection = (
    connection: UpdateFtpConnectionParams
  ): ApiResponseAsync<FtpConnectionGeneral> => {
    const link = ApiPaths.ftpConnections.byId._({
      [ApiUrlParams.ftpConnectionId]: connection.ftpConnectionId,
    });
    return this.helpers.handlePut(link, connection);
  };

  addConnection = (
    connection: ValidateFtpCredentials
  ): ApiResponseAsync<FtpConnectionGeneral> => {
    const link = ApiPaths.ftpConnections._();
    return this.helpers.handlePost(link, connection);
  };

  getConnections = (): ApiResponseAsync<
    DataWithTotal<FtpConnectionGeneral>
  > => {
    const link = ApiPaths.ftpConnections._();
    return this.helpers.handleGet(link);
  };
}
